<!--
  Copyright (c) 2022-2026 GM Global Technology Operations LLC. All rights reserved.
  This information is confidential and proprietary to GM Global Technology
  Operations LLC and may not be used, modified, copied or distributed.
  -->
<br/>
<h1 class="page-header">Netlist Compare</h1>
<br/>
@if (permission()) {
    <table class="files-input" [class.hidden]="!showFileInput">
    <tr>
      <td><h4>*HRN File(s) 1:</h4></td>
      <td><input type="file" webkitdirectory directory multiple (change)="selectHrn1Files($event)"
      #hrnFile1Tag/></td>
      @if (hrnFile1) {
        <button pButton size="small" pRipple type="button"
          class="p-button-rounded p-button-text"
        (click)="clearHrn1File();"><i class="pi pi-times" pButtonIcon></i></button>
      }
    </tr>
    <tr>
      <td><h4>*HRN File(s) 2:</h4></td>
      <td><input type="file" webkitdirectory directory multiple (change)="selectHrn2Files($event)"
      #hrnFile2Tag/></td>
      @if (hrnFile2) {
        <button pButton size="small" pRipple type="button"
          class="p-button-rounded p-button-text"
        (click)="clearHrn2File();"><i class="pi pi-times" pButtonIcon></i></button>
      }
    </tr>
    <tr>
      <td><h4>PROL File:</h4></td>
      <td><input type="file" (change)="selectProlFile($event)" #prolFileTag
      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"/></td>
      @if (prolFile) {
        <button pButton size="small" pRipple type="button"
          class="p-button-rounded p-button-text"
        (click)="clearProlFile();"><i class="pi pi-times" pButtonIcon></i></button>
      }
    </tr>
    <tr>
      <td><h4>PLOC File:</h4></td>
      <td><input type="file" (change)="selectPlocFile($event)" #plocFileTag
      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"/></td>
      @if (plocFile) {
        <button pButton size="small" pRipple type="button"
          class="p-button-rounded p-button-text"
        (click)="clearPlocFile();"><i class="pi pi-times" pButtonIcon></i></button>
      }
    </tr>
    <tr>
      <td></td>
      <td>
        <div class="buttons">
          <p-button label="Generate Report" icon="pi pi-check" class="gm-btn-primary mr-2"
            [disabled]="! (hrnFile1 && hrnFile2) || !permission()" (click)="generateReport()">
          </p-button>
        </div>
      </td>
    </tr>
  </table>
}

@if (progress() > 0) {
  <p-progressBar mode="indeterminate" [style]="{ height: '6px' }"></p-progressBar>
}
@if (userPrompt) {
  <div class="alert alert-success" role="alert">{{userPrompt}}
    <button pButton size="small" pRipple type="button"
      class="p-button-rounded p-button-text"
    (click)="userPrompt = null;"><i class="pi pi-times" pButtonIcon></i></button>
  </div>
}
@if (!showFileInput) {
  <table>
    @if (gmNetlistCompareResultsHolder && (gmNetlistCompareResultsHolder.harnessOverlapSet?.length ?? 0) > 0) {
      <tr>
        <div style="padding-left: 15px">
          {{gmNetlistCompareResultsHolder.harnessOverlapSet}}
          {{harnessName}}
          <p-select [options]="gmNetlistCompareResultsHolder.harnessOverlapSet" [(ngModel)]="harnessName" [showClear]="true" placeholder="Select Harness">
          </p-select>
        </div>
      </tr>
    }
    <tr>
      <div class="buttons">
        <p-button label="Generate Report" icon="pi pi-check" class="gm-btn-primary mr-2"
          [disabled]="!(hrnFile1 && hrnFile2) || !permission() || !(harnessName || singleMismatch)"
          (click)="generateReport()">
        </p-button>
        <p-button label="Change Files" icon="pi pi-refresh" severity="warn" class="mr-2"
          (click)="showFileInput = true; userPrompt = null; harnessName = null">
        </p-button>
      </div>
    </tr>
  </table>
}





